import React from "react";
import { Trash2, Plus } from "lucide-react";
import { Button } from "../ui/button";

export const Section = ({ title, desc, children, actions }) => (
  <section className="bg-white rounded-xl border border-slate-200 p-6 space-y-4">
    <div className="flex items-start justify-between gap-3 flex-wrap">
      <div>
        <h3 className="text-lg font-bold text-slate-900">{title}</h3>
        {desc && <p className="text-xs text-slate-500 mt-0.5">{desc}</p>}
      </div>
      {actions}
    </div>
    <div className="space-y-4">{children}</div>
  </section>
);

export const Field = ({ label, children, hint }) => (
  <div>
    <label className="text-xs font-semibold text-slate-700 mb-1 block">{label}</label>
    {children}
    {hint && <p className="text-[11px] text-slate-400 mt-1">{hint}</p>}
  </div>
);

export const Card = ({ children, onDelete, title }) => (
  <div className="relative bg-slate-50 rounded-lg border border-slate-200 p-4 space-y-3">
    <div className="flex justify-between items-center">
      <span className="text-xs font-bold uppercase tracking-wider text-slate-500">{title}</span>
      {onDelete && (
        <button type="button" onClick={onDelete} className="text-red-600 hover:text-red-800 p-1">
          <Trash2 className="w-4 h-4" />
        </button>
      )}
    </div>
    {children}
  </div>
);

export const AddButton = ({ onClick, label = "Ekle" }) => (
  <Button type="button" variant="outline" size="sm" onClick={onClick} className="gap-2 border-dashed">
    <Plus className="w-4 h-4" /> {label}
  </Button>
);
